<template>
  <div class="users">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Users</span>
        <span slot="link">
          <router-link class="btn btn-primary pull-right" :to="{ path: `user/add` }">
            Add User
          </router-link>
        </span>
      </heading-wrap>

      <spinner v-if="loading" />
      <slot-table :data="formattedUsers" :columns="table.columns">

        <template slot="clients" slot-scope="props">
          <span v-for="(client, index) in props.item.clients" :key="index">{{ client.name }}<span v-if="index == props.item.clients.length - 1"></span><span v-else>, </span>
          </span>
        </template>

        <template slot="last_login" slot-scope="props">
          <span v-if="props.item.last_login">{{ props.item.last_login.date | fromNow }} </span>
        </template>

        <template slot="userActions" slot-scope="props">
              <span v-if="props.item.userActions">
                <router-link class="btn btn-warning btn-xs" :to="{ path: `user/${props.item.hash_id}/edit` }">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                </router-link>
                <button-cta title="confirm" data-modalType="deleteUser" :data-modalID="props.item.hash_id" :data-modalField="props.item.name" :onClick="onLaunchModal" class="btn btn-danger btn-xs">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button-cta>
                <button-cta title="confirm" data-modalType="resetUser" :data-modalID="props.item.hash_id" :data-modalField="props.item.name" :onClick="onLaunchModal"
                            class="btn btn-danger btn-xs">
                  <i class="fa fa-shield" aria-hidden="true"></i>
                </button-cta>
              </span>
        </template>
      </slot-table>
    </div>

    <portal to="globalModal">
      <modal-user-confirm :show="showModal.deleteUser" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('deleteUser')"/>
      <modal-reset-user :show="showModal.resetUser" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('resetUser')"/>
    </portal>

  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import ButtonCta from '@/components/Button/button'
import {userMixin} from '@/mixins/userMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import ModalUserConfirm from '@/components/Modal/users/modal-user-confirm'
import ModalResetUser from '@/components/Modal/users/modal-reset-user'

import { assoc, map } from 'ramda'

export default {
  name: 'Users',
  mixins: [userMixin, modalMixin, notificationMixin],
  components: {
    HeadingWrap,
    SlotTable,
    ButtonCta,
    Spinner,
    ModalUserConfirm,
    ModalResetUser
  },
  data: () => ({
    // loading: false,
    table: {
      columns: {
        name: 'Name',
        email: 'Email',
        roleName: 'Role',
        client_names: 'Clients',
        last_login: 'Last Login',
        userActions: ''
      }
    }
  }),
  created () {
    this.startLoading()
    this.getUsers().then(() => {
      this.finishLoading()
      console.log('Users loaded.', this.users)
    }, error => {
      this.finishLoading()
      this.addNotification('danger', error)
    })
  },
  computed: {
    formattedUsers () {
      // add userActions key/value to data
      return map(item => assoc('userActions', true, item), this.users)
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/user/users.vue